import type { EmployeeType } from '../services/api/models/EmployeeType';

/** Display labels for the per-clinic employee type. */
const EMPLOYEE_TYPE_LABELS: Record<EmployeeType, string> = {
  STAFF: 'Staff',
  CONTRACT: 'Contract',
  PAY_PER_VISIT: 'Pay Per Visit',
  PER_DIEM: 'Per Diem',
  OTHER: 'Other',
  PART_TIME: 'Part Time',
  PRN: 'PRN',
  CONTRACTOR_PRN: 'Contractor PRN',
  CONTRACTOR_PART_TIME: 'Contractor Part Time',
};

export const EMPLOYEE_TYPE_OPTIONS: Array<{
  value: EmployeeType;
  label: string;
}> = (Object.keys(EMPLOYEE_TYPE_LABELS) as EmployeeType[]).map(value => ({
  value,
  label: EMPLOYEE_TYPE_LABELS[value],
}));

/** Label for a row, resolving OTHER to its free-text value when present. */
export function employeeTypeLabel(
  employeeType: EmployeeType | null | undefined,
  employeeTypeOther?: string | null
): string {
  if (!employeeType) return '';
  if (employeeType === 'OTHER' && employeeTypeOther) return employeeTypeOther;
  return EMPLOYEE_TYPE_LABELS[employeeType];
}
